import { createAsyncThunk } from '@reduxjs/toolkit';
import { KeywordRepositoryImpl } from '../Data/repositories/KeywordRepositoryImpl';
import { KeywordOptimizationUseCase } from '../Domain/UseCase/KeywordOptimizationUseCase';
import { KeywordOptimizationRequest, KeywordOptimizationResponse, KeywordOptimizationError } from '../Model/KeywordOptimization';
import { setLoading, setResult, setError } from './reducers';

const repo = new KeywordRepositoryImpl();
const useCase = new KeywordOptimizationUseCase(repo);

export const optimizeKeywords = createAsyncThunk<
  KeywordOptimizationResponse,
  KeywordOptimizationRequest,
  { rejectValue: KeywordOptimizationError }
>(
  'keyword/optimize',
  async (request: KeywordOptimizationRequest, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));
      
      const result = await useCase.execute(request);
      
      if (result.isOk()) {
        dispatch(setResult(result.value));
        return result.value;
      } else {
        const error = result.error;
        dispatch(setError(error));
        return rejectWithValue(error);
      }
    } catch (error) {
      const fallbackError: KeywordOptimizationError = {
        type: 'API_ERROR',
        message: '키워드별 순위 조회 중 오류가 발생했습니다.',
        details: error instanceof Error ? error.message : String(error)
      };
      dispatch(setError(fallbackError));
      return rejectWithValue(fallbackError);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
